/** Routes of the legal pages (kept apart from their content so the router doesn't pull the copy into the main bundle). */
export const LEGAL_PATHS = ['/terms', '/privacy', '/risk-disclosure'] as const;
